import React, { Component } from 'react';
import '../css/trimmis.scss';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css'

class SingleSlider extends Component {


  constructor (props, context) {
    super(props, context);
    this.state = {
      value: this.props.value
    };
  }

  handleChangeComplete = (e) => {

  };

  render() {
    return (
        <div className='slider'>
          <Slider
              min={this.props.min}
              max={this.props.max}
              value={this.props.value}
              onChange={this.props.change}
              onChangeComplete={this.handleChangeComplete}
          />
        </div>
    );
  }
}

export default SingleSlider;


// WEBPACK FOOTER //
// ../components/SingleSlider.js